export interface StaticDeploymentPolicy {
  id: string;
  version: string;
  hostingTarget: 'cloudflare_pages';
  staticOnly: true;
  backend: false;
  database: false;
  cloudFunctions: false;
  serverPdf: false;
  analytics: false;
  monthlyFixedCostTargetUsd: 0;
  spaFallback: true;
  securityHeadersRequired: true;
  disclosure: string;
}

export const DEFAULT_STATIC_DEPLOYMENT_POLICY: StaticDeploymentPolicy = Object.freeze({
  id: 'DEPLOY-CLOUDFLARE-PAGES-STATIC',
  version: '1.0.0',
  hostingTarget: 'cloudflare_pages',
  staticOnly: true,
  backend: false,
  database: false,
  cloudFunctions: false,
  serverPdf: false,
  analytics: false,
  monthlyFixedCostTargetUsd: 0,
  spaFallback: true,
  securityHeadersRequired: true,
  disclosure: '正式 V1 以 Cloudflare Pages 純靜態部署為目標；排盤、解讀、保存與列印都在瀏覽器完成，不需要 Backend、Database、Functions 或伺服器 PDF。',
});

export function assertStaticDeploymentPolicy(policy: StaticDeploymentPolicy = DEFAULT_STATIC_DEPLOYMENT_POLICY): void {
  if (policy.hostingTarget !== 'cloudflare_pages' || !policy.staticOnly) throw new Error('V1 deployment must remain a static Cloudflare Pages target');
  for (const [key, value] of Object.entries(policy)) {
    if (['backend', 'database', 'cloudFunctions', 'serverPdf', 'analytics'].includes(key) && value !== false) {
      throw new Error(`V1 static deployment policy must keep ${key} disabled`);
    }
  }
  if (policy.monthlyFixedCostTargetUsd !== 0) throw new Error('V1 static deployment monthly fixed cost target must remain 0 USD');
  if (!policy.spaFallback) throw new Error('Static deployment must retain SPA fallback routing');
  if (!policy.securityHeadersRequired) throw new Error('Static deployment must require audited security headers');
}

export function renderCloudflarePagesRedirects(): string {
  return '/* /index.html 200\n';
}
